import { Component, effect } from '@angular/core';
import { CommunityCalendar } from '../community-calendar/community-calendar';
import { UserService } from '../../user.service';

@Component({
  selector: 'app-community-calendar-page',
  imports: [CommunityCalendar],
  templateUrl: './community-calendar-page.html',
  styleUrl: './community-calendar-page.scss'
})
export class CommunityCalendarPage {

	constructor( protected userService: UserService ) { 
		effect(() => {
			const tenant = this.userService.currentTennant();
			this.language = tenant ? tenant.Language : 1;
		});
	}

	protected language: number = 1;

	contentStrings : Record<string, Record<number, string>> = {
		WelcomeBack: { 1: "Welcome Back", 2: "お帰りなさい" },
		CurrentBalance: { 1: "Current Balance", 2: "現在の残高" },
		NextPaymentDate: { 1: "Next Payment Date", 2: "次の支払日" },
		PastPayments: { 1: "Past Payments", 2: "過去の支払い" },
		MyMCXPortal: { 1: "My MCX Portal", 2: "マイMCXポータル" },
		CommunityCalendar: { 1: "Community Calendar", 2: "コミュニティカレンダー" },
	}
}
